export const PageContact = () => {

  return (
    <>
      <h1>Contact us</h1>
    </>
  );
};

